import * as React from 'react';
import styled from 'styled-components';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const FeedbackThumbIcon = React.memo(function FeedbackThumbIcon(props: TFeedbackThumbIconProps): React.ReactElement {
    const { score = 0, ...elementProps } = props;
    return (
        <SIconBase aria-label={`Feedback score ${score + 1}`} {...elementProps} $score={score}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.3764 16.8654C11.5839 17.681 12.0201 17.9561 12.2798 17.9934C12.4981 18.0249 12.9172 17.9278 13.2365 17.1828C13.6553 16.2057 13.7633 15.1233 13.5458 14.0827L13.5191 13.9548L12.509 13.8827C12.0958 13.8532 11.7848 13.4943 11.8143 13.0812C11.8438 12.668 12.2027 12.357 12.6158 12.3865L14.1908 12.499L17.1874 12.713C18.0823 12.777 18.7895 11.9663 18.6047 11.0884L17.4295 5.50649C17.298 4.88178 16.7469 4.4346 16.1085 4.4346H7.8374V12.4673C9.94614 12.9602 10.8994 14.9907 11.3764 16.8654ZM7.60508 13.9583C8.7685 14.2994 9.47846 15.4893 9.92271 17.2353C10.2276 18.4337 11.0203 19.3276 12.066 19.4781C13.1531 19.6347 14.1159 18.9387 14.6152 17.7737C15.1165 16.604 15.2725 15.3174 15.068 14.0655L17.0806 14.2092C18.9698 14.3442 20.4627 12.6328 20.0725 10.7794L18.8973 5.19747C18.6197 3.87865 17.4562 2.9346 16.1085 2.9346H7.64771C7.38112 2.44323 6.86072 2.10961 6.2624 2.10961H4.1624C3.29255 2.10961 2.5874 2.81476 2.5874 3.68461V13.1346C2.5874 14.0045 3.29255 14.7096 4.1624 14.7096H6.2624C6.83029 14.7096 7.32798 14.4091 7.60508 13.9583ZM4.1624 13.2096H6.2624C6.30382 13.2096 6.3374 13.176 6.3374 13.1346V3.68461C6.3374 3.64319 6.30382 3.60961 6.2624 3.60961H4.1624C4.12098 3.60961 4.0874 3.64319 4.0874 3.68461V13.1346C4.0874 13.176 4.12098 13.2096 4.1624 13.2096Z"
            />
        </SIconBase>
    );
});

export default FeedbackThumbIcon;

// #region Styles

const SIconBase = styled(IconBase)<{ $score: TFeedbackThumbIconScore }>`
    ${(p) => p.$score === 1 && 'transform: scaleY(-1);'}
`;

// #endregion

// #region Types

type TFeedbackThumbIconScore = 0 | 1;

export type TFeedbackThumbIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>> & {
        score?: TFeedbackThumbIconScore;
    };

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function'
        ? () => <FeedbackThumbIcon />
        : {
              ...IconBaseExample,
              render: FeedbackThumbIcon,
              controls: { score: [0, 1], ...IconBaseExample.controls },
          };

// #endregion
